import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/ticket-selling/ticket-selling.routes').then(m => m.ROUTES),
  },
];
